export default [
    {
        path: '/callback',
        name: 'auth-callback',
        component: () => import('@/views/auth/Callback.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/login',
        name: 'page-login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/register',
        name: 'page-register',
        component: () => import('@/views/auth/Register.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/forgot-password',
        name: 'page-forgot-password',
        component: () => import('@/views/auth/ForgotPassword.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/reset-password',
        name: 'page-reset-password',
        component: () => import('@/views/auth/ResetPassword.vue'),
        meta: {
            rule: 'editor'
        }
    }
]
